import React from 'react';
import {
  Image,
  StyleSheet,
  View,
  Text,
  TouchableHighlight,
} from '../base_components';

const styles = StyleSheet.create({
  textButton: {
    height: '3.5rem',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '0.5em',
    overflow: 'hidden',
  },
  highlight: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  disabled: {
    backgroundColor: '#999',
  },
  inner: {
    paddingLeft: '1rem',
    paddingRight: '1rem',
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    color: 'black',
    fontSize: '1.3rem',
    fontWeight: '600',
  },
  iconView: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: '0.2rem',
    width: '4rem',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    height: '2.2rem',
    width: '2.2rem',
  },
  blueButton: {
    backgroundColor: '#0a60fe',
  },
  ghostBorder: {
    borderColor: 'white',
    borderWidth: 1,
    backgroundColor: 'transparent',
  },
  ghostText: {
    color: 'white',
  },
  ghostInvertedBorder: {
    borderColor: '#0a60fe',
    borderWidth: 1,
    backgroundColor: 'transparent',
  },
  ghostInvertedText: {
    color: '#0a60fe',
  },
  emptyButton: {
    backgroundColor: 'transparent',
  },
  blueText: {
    color: '#0a60fe',
  },
  whiteText: {
    color: 'white',
  },
  disabledButton: {
    backgroundColor: '#999',
  },
  disabledText: {
    color: 'white',
  },
});

type Props = {
  style?: any;
  textStyle?: any;
  highlightStyle?: any;
  type?: 'default' | 'ghost' | 'borderless' | 'ghost-inverted' | 'disabled';
  text: string;
  disabled?: boolean;
  icon?: any;
  onPress?: () => void;
  underlayColor?: string;
};

export default class TextButton extends React.PureComponent<Props> {
  render() {
    const {
      style,
      textStyle,
      highlightStyle,
      icon,
      text,
      type,
      onPress,
      underlayColor,
    } = this.props;

    const disabled = this.props.disabled || type === 'disabled';

    let buttonExtra = null;
    let textExtra = null;
    if (disabled) {
      buttonExtra = styles.disabledButton;
      textExtra = styles.disabledText;
    } else if (type === 'default') {
      buttonExtra = styles.blueButton;
      textExtra = styles.whiteText;
    } else if (type === 'ghost') {
      buttonExtra = styles.ghostBorder;
      textExtra = styles.ghostText;
    } else if (type === 'ghost-inverted') {
      buttonExtra = styles.ghostInvertedBorder;
      textExtra = styles.ghostInvertedText;
    } else if (type === 'borderless') {
      buttonExtra = styles.emptyButton;
      textExtra = styles.blueText;
    }

    let icon_img = null;
    if (icon) {
      icon_img = (
        <View style={styles.iconView}>
          <Image style={styles.icon} resizeMode='contain' source={icon} />
        </View>
      );
    }

    return (
      <View style={[styles.textButton, buttonExtra, style]}>
        <TouchableHighlight
          style={[styles.highlight, highlightStyle]}
          underlayColor={underlayColor || 'rgba(0,0,0,0.2)'}
          onPress={disabled ? noop : onPress}
        >
          <View style={styles.inner}>
            <Text style={[styles.text, textExtra, textStyle]}>{text}</Text>
            {icon_img}
          </View>
        </TouchableHighlight>
      </View>
    );
  }
}
function noop() {}
